import { render } from "./EnrolleeAdd.vue?vue&type=template&id=6b0a09f3&scoped=true"
import script from "./EnrolleeAdd.vue?vue&type=script&lang=js"
export * from "./EnrolleeAdd.vue?vue&type=script&lang=js"

import "./EnrolleeAdd.vue?vue&type=style&index=0&id=6b0a09f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0a09f3"]])

export default __exports__